export const productsCategories = ["phone", "tv", "pc", "console"];
export const productsKeyTypes = {
  productName: "productName",
  productPrice: "productPrice",
  productCategory: "productCategory",
  productQuantity: "productQuantity",
};
